// extracted by mini-css-extract-plugin
module.exports = {"findMeContainer":"FindMeBox_findMeContainer__zzcrk","contentContainer":"FindMeBox_contentContainer__ZXsiO","findTitle":"FindMeBox_findTitle__1V1O5"};